import { http } from "../http-common";
import { Owner } from "../models/Owner";

class OwnerDataService {
    async get(client: string, password: string, portalId: string) {
        return await http(client, password).get<Owner[]>(`/hubspot/portal/${portalId}/owners`);
    }
}
export default new OwnerDataService();